"use client";

import { useLocalStorage } from "hooks/use-local-storage";
import { useEffect } from "react";

import {
  closeSubscribeDialog,
  openSubscribeDialog,
} from "@/context/redux/reducers/dialog/subscribe-dialog-slice";
import { useAppDispatch } from "@/hooks/redux-hooks";
import { useVerifyServiceQuota } from "@/hooks/use-verify-access-limit";

export const SubscribeDialogTrigger = () => {
  const dispatch = useAppDispatch();
  const { blocked } = useVerifyServiceQuota();
  const [isCI] = useLocalStorage("CI", undefined);

  useEffect(() => {
    if (isCI) return;
    if (blocked) dispatch(openSubscribeDialog());

    return () => {
      dispatch(closeSubscribeDialog());
    };
  }, [blocked, dispatch, isCI]);

  return null;
};
